/**
 * Concatenates multiple source fields into a single target field using a separator.
 *
 * Config shape:
 * {
 *     logicType: 'calcFields',
 *     operationType: 'header.merge',
 *     fieldsToMerge: ['productSku', 'version'],
 *     separator: '-',
 *     targetField: 'name'
 * }
 */
const headerMerge = (data, operation) => {
    const { fieldsToMerge, separator = '', targetField } = operation

    if (!Array.isArray(fieldsToMerge) || !targetField) return data

    const parts = fieldsToMerge.map(f => data[f] ?? '')
    if (parts.some(p => !p)) return data

    return { ...data, [targetField]: parts.join(separator) }
}

export default headerMerge
